import PropTypes from 'prop-types'
import { createContext, useContext, useState, useMemo, useCallback, useRef } from 'react'

// ----------------------------------------------------------------------

const initialState = {
  navData: null,
  setNavData: () => {},
  resetNavData: () => {},
  simulatorModal: { current: null },
  notifyTransactionModal: { current: null },
}

const NavVerticalContext = createContext(initialState)

export const useNavVerticalContext = () => {
  const context = useContext(NavVerticalContext)

  if (!context) throw new Error('useNavVerticalContext must be use inside NavVerticalProvider')

  return context
}

// ----------------------------------------------------------------------

NavVerticalProvider.propTypes = {
  children: PropTypes.node,
}

export function NavVerticalProvider({ children }) {
  const [navData, setNavData] = useState(null)

  const simulatorModal = useRef(null)
  const notifyTransactionModal = useRef(null)

  const resetNavData = useCallback(() => {
    setNavData(null)
  }, [])

  const memoizedValue = useMemo(
    () => ({
      navData,
      setNavData,
      resetNavData,
      simulatorModal,
      notifyTransactionModal,
    }),
    [navData, resetNavData]
  )

  return <NavVerticalContext.Provider value={memoizedValue}>{children}</NavVerticalContext.Provider>
}
